import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { HttpModule, RequestOptions, XHRBackend } from "@angular/http";
import { HashLocationStrategy, LocationStrategy } from "@angular/common";
import { RouterModule, Routes } from "@angular/router";
import { DialogComponent } from "./shared/component/dialog-box/dialog.component";
import { MainModule } from "./section/main/main.module";
import { LoginComponent } from "./section/login/login.component";
import { AppComponent } from "./app.component";
import { ValidateLoginService } from "./component/shared/validate-login.service";
import { ValidateLoggOfService } from "./component/shared/validate-logg-Of.service";
import { AuthServiceService } from "./component/service/auth-service.service";
import { LoginService } from "./component/service/login/login.service";
import { NotFoundComponent } from "./component/not-found/not-found.component";
import { RightSidebarComponent } from "./component/home/right-sidebar/right-sidebar.component";
import { LeftSidebarComponent } from "./component/home/left-sidebar/left-sidebar.component";
import { PatientService } from "./section/patient/service/patient-service.service";
import { MedicalHistoryService } from "./section/master/services/medical-history.service";
import { SharedService } from "./component/shared/shared.service";
import { HomeComponent } from "./component/home/home.component";
import {
  HttpService,
  customHttpProvider
} from "./shared/service/http/interceptor-service.service";
import { SharedModule } from "./shared/shared.module";
import { CookiesService } from "./shared/service/cookies/cookies.service";
import { SessionService } from "./shared/service/session/session.service";
import { LockComponent } from "./section/lock/lock.component";
import { UserService } from "./section/user/service/user.service";
import { AppointmentService } from "./section/appointment/service/appointment.service";
import { ServiceMasterService } from "./section/master/services/service-master.service";
import { MyDatePickerModule } from "mydatepicker";
import { EditPatientForDialogComponent } from "./section/patient/edit-patient/edit-patient.component";
import { PrescriptionComponent } from "./section/patient/view-patient-profile/prescription/prescription.component";
import { AddAppointmentDialogComponent } from "./section/appointment/add-appointment/add-appointment.component";
import { ViewMedicalHistoryComponent } from "./section/patient/view-medical-history/view-medical-history.component";
import { FogetPasswordComponent } from "./section/foget-password/foget-password.component";
import { PrintComponent } from "./section/print/print.component";
import { NO_ERRORS_SCHEMA } from "@angular/core";
import { PrescriptionService } from "./section/patient/service/prescription.service";
import { ClinicalNotesService } from "./section/patient/service/clinical-notes.service";
import { DrugServiceService } from "./section/master/services/drug-service.service";
import { CKEditorModule } from "ng2-ckeditor";
import { ContactUsService } from "./section/user/service/contact-us.service";
import { CorporateService } from "./section/master/services/corporate.service";
export function routedata() {
  return MainModule;
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    NotFoundComponent,
    HomeComponent,
    RightSidebarComponent,
    LeftSidebarComponent,
    DialogComponent,
    LockComponent,
    EditPatientForDialogComponent,
    ViewMedicalHistoryComponent,
    AddAppointmentDialogComponent,
    FogetPasswordComponent,
    PrintComponent,
    PrescriptionComponent
    
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    SharedModule,
    MyDatePickerModule,
    CKEditorModule,
    RouterModule.forRoot([
      {
        path: "login",
        component: LoginComponent,
        canActivate: [ValidateLoggOfService]
      },
      { path: "Prescription/:appointmentid", component: PrintComponent },
      {
        path: "forgot",
        component: FogetPasswordComponent,
        canActivate: [ValidateLoggOfService]
      },
      {
        path: "lock",
        component: LockComponent,
        canActivate: [ValidateLoggOfService]
      },
      {
        path: "main",
        component: HomeComponent,
        loadChildren: routedata,
        data: { requiresLogin: true },
        canActivate: [ValidateLoginService]
      },
      { path: "", redirectTo: "login", pathMatch: "full" },
      { path: "**", component: NotFoundComponent }
    ])
  ],
  providers: [
    ValidateLoginService,
    AuthServiceService,
    ValidateLoggOfService,
    SharedService,
    LoginService,
    PatientService,
    MedicalHistoryService,
    UserService,
    AppointmentService,
    ServiceMasterService,
    customHttpProvider,
    PrescriptionService,
    ClinicalNotesService,
    DrugServiceService,
    ContactUsService,
    CorporateService,
    { provide: LocationStrategy, useClass: HashLocationStrategy }
  ],

  bootstrap: [AppComponent],
  schemas: [NO_ERRORS_SCHEMA]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts